import { Link } from "react-router-dom";
import { articles, type Article } from "@/mocks/articles";

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="bg-gray-50/80 py-14 md:py-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            精选推荐
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            编辑精选优质内容，为你推荐最值得看的视频和资讯
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article: Article) => (
            <FeaturedCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-amber-200 transition-all duration-300 cursor-pointer hover:-translate-y-1"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-amber-500 text-white text-xs font-medium rounded-full">
            精选
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-amber-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-gray-500 line-clamp-2 mb-4 leading-relaxed">
          {article.description}
        </p>
        <div className="flex items-center justify-between text-xs text-gray-400">
          <span>{article.date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}